import user from './user'
import company from './company'
import server from './server'

export default {
    user,
    company,
    server
}


// WEBPACK FOOTER //
// ./src/store/modules/index.js